"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundPage = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const react_i18next_1 = require("react-i18next");
const NotFoundPage = () => {
    const { t } = (0, react_i18next_1.useTranslation)('auth');
    return (react_1.default.createElement("div", null,
        "404 - ",
        react_1.default.createElement(react_router_1.Link, { to: "/" }, t('auth:BackToHomePage'))));
};
exports.NotFoundPage = NotFoundPage;
exports.default = exports.NotFoundPage;
//# sourceMappingURL=NotFoundPage.js.map